import { createAction } from '@reduxjs/toolkit'
import { call, ForkEffect, put, select, takeLatest } from 'redux-saga/effects'

import { IMaterialModificationConflict } from '../../../models/masterSetPlan'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { updateSelectedPaperId } from '../../slices/2D'
import { selectAreConflictsBeingReviewed, selectSavedMaterialModifications } from '../../slices/masterSetPlan'
import { setDeletionModalVisible } from '../../slices/tools'

export const selectModificationForDeletionAction = createAction<number>('selectModificationForDeletion')

export function* handleSelectModificationForDeletion(
    action: ReturnType<typeof selectModificationForDeletionAction>
): Generator {
    const manager: PaperManager | null = (yield call(managers.get2DManager)) as PaperManager | null

    if (!manager) return

    const [workspaceTool]: [Workspace] = (yield call(manager.getTools, [Workspace.NAME])) as [Workspace]

    const items: paper.Item[] | null = (yield call(
        [workspaceTool, workspaceTool.getItemsWithCriteria],
        'data',
        (data: any) => data?.isModification === true && data?.opening_location_id === action.payload
    )) as paper.Item[] | null

    if (!items?.length) return

    const areConflictsBeingReviewed: boolean = (yield select(selectAreConflictsBeingReviewed)) as boolean

    if (areConflictsBeingReviewed) {
        const savedMods: IMaterialModificationConflict[] = (yield select(
            selectSavedMaterialModifications
        )) as IMaterialModificationConflict[]

        const savedMod = savedMods.find((m) => m.material_location_id === action.payload) ?? null

        if (savedMod) {
            items[0].data.materialModificationConflict = savedMod
            items[0].data.isTemporary = false
        }
    }

    yield put(updateSelectedPaperId(items[0].id))
    yield put(setDeletionModalVisible(true))
}

export function* watchForSelectModificationForDeletion(): Generator<ForkEffect<never>, void, unknown> {
    yield takeLatest(selectModificationForDeletionAction.type, handleSelectModificationForDeletion)
}
